var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7307 3.97945C15.9025 3.09596 14.766 2.60938 13.5304 2.60938C12.6068 2.60938 11.761 2.89656 11.0163 3.46287C10.6406 3.7487 10.3002 4.09846 10 4.50661C9.69994 4.09855 9.35938 3.7487 8.98353 3.46287C8.239 2.89656 7.39319 2.60938 6.46959 2.60938C5.234 2.60938 4.09741 3.09596 3.26916 3.97945C2.45081 4.85262 2 6.04551 2 7.3385C2 8.6693 2.50428 9.88755 3.58691 11.1724C4.55541 12.3217 5.94737 13.4884 7.55931 14.8394C8.10975 15.3008 8.73366 15.8237 9.38147 16.3808C9.55264 16.5282 9.77246 16.6095 10 16.6094C10.2277 16.6094 10.4474 16.5282 10.6183 16.381C11.2661 15.8238 11.8904 15.3006 12.441 14.839C14.0528 13.4882 15.4447 12.3217 16.4132 11.1722C17.4958 9.88758 18 8.66933 18 7.33838C18 6.04551 17.5492 4.85262 16.7307 3.97945Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.0d202ac87dacf6eadac8974f55c93568.svg";
export { ForwardRef as ReactComponent };